import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { AdyenGooglePayComponentDef } from '@df/module-adyen/google-pay/adyen-google-pay.component.def';
import { CheckoutFormComponent } from '../../../checkout/form/checkout-form.component';
import { CheckoutStepComponent } from '../../../checkout/step/checkout-step.component';
@Component({
    selector: 'adyen-google-pay',
    templateUrl: './adyen-google-pay.html',
    styleUrls: ['./adyen-google-pay.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class AdyenGooglePayComponent extends AdyenGooglePayComponentDef {
    constructor(
        checkoutFormComponent: CheckoutFormComponent,
        _ref: ChangeDetectorRef,
        protected override scrollToService: ScrollToService,
        checkoutStepcomponent: CheckoutStepComponent,
    ) {
        super(checkoutFormComponent, _ref, scrollToService, checkoutStepcomponent);
    }
}
